(function($){
	$(document).ready(function(){
		if (typeof $.fn.magnificPopup !== 'undefined') {
			
			$('.gallery-row').magnificPopup({
				delegate: 'a.gallery-img-link',
				closeBtnInside: false,
				type: 'image',
				gallery: {
					enabled: true,
					navigateByImgClick: true
				}
			});

			$('.vital-gallery').magnificPopup({
				delegate: '.gallery-item a',
				closeBtnInside: false,
				type: 'image',
				gallery: {
					enabled: true,
					navigateByImgClick: true
				}
			});
		}
	});
})(jQuery);
